import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { catchError, filter, map, of } from 'rxjs';
import { requiereSesion, RUTAS_ONBOARDING } from '@core/constants/rutas.constants';
import { SesionApiService } from '@core/services/sesion/sesion-api.service';
import { LimpiezaSesionService } from '@core/services/limpieza-sesion/limpieza-sesion.service';

@Injectable({ providedIn: 'root' })
export class RestauracionSesionService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly router = inject(Router);
  private readonly sesionApiService = inject(SesionApiService);
  private readonly limpiezaSesionService = inject(LimpiezaSesionService);

  public activar(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    window.addEventListener('pageshow', this.alRestaurarPagina);
  }

  /* Al volver con el botón atrás desde un sitio externo el navegador restaura el documento desde
     el bfcache: no hay recarga, Angular no vuelve a arrancar y ni el guard de secuencia ni el
     sesionResolver llegan a ejecutarse. Sin esta revalidación la página queda usable con la sesión
     ya muerta y el usuario solo se entera al enviar el formulario. */
  private readonly alRestaurarPagina = (evento: PageTransitionEvent): void => {
    if (!evento.persisted) return;
    if (!requiereSesion(this.router.url)) return;

    this.revalidarSesion();
  };

  private revalidarSesion(): void {
    this.sesionApiService
      .verificarSesion()
      .pipe(
        map(() => true),
        catchError(() => of(false)),
        filter((vigente) => !vigente),
      )
      .subscribe(() => {
        this.limpiezaSesionService.limpiarEstadoLocal();
        void this.router.navigate([RUTAS_ONBOARDING.BIENVENIDA]);
      });
  }
}
